"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgVkLogo = function SvgVkLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.706.773S6.777.035 7.743.012c.966-.024 2.765 0 2.765 0s1.197.06 1.197.979v3.46s-.016.937.446 1.038c.462.101 1.196-.916 1.556-1.504.36-.588 1.513-2.785 1.513-2.785s.177-.727.675-.727h3.265s1.288.02.764 1.079c-.523 1.06-2.684 3.937-2.684 3.937s-.842 1.03 0 1.765c.843.735 1.976 1.962 2.244 2.323.268.36 1.039 1.718 0 1.718h-3.395s-1.029-.141-1.705-.942c-.677-.801-1.26-1.674-1.86-1.687-.6-.013-.82 1.687-.82 1.687s.005.942-.747.942-2.946.257-4.722-1.105C4.459 8.827 4.07 8.229 3.153 6.859 2.235 5.489.29 1.746.29 1.746S-.415.473.59.473h2.562s.778-.117 1.22.92c.441 1.035 1.13 2.389 1.862 3.242.73.854 1.192 1.466 1.508.316.182-1.596.182-2.25.182-2.25S7.816 1.41 7.488 1.2c-.33-.21-.782-.427-.782-.427Z",
    fill: "#fff"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgVkLogo);
var _default = exports["default"] = Memo;